<template>
	<section>
		<bread-crumb></bread-crumb>
		<div class='service-box'>
			<div class="service-first">
				<h1>服务项目<span>*</span></h1>
				<ul class='service-list'>
					<li v-for='(item,index) in serverList' :key='index' :class='flag==index?"current":""' @click="selectServer(item,index)">
						<span>{{item.server_name}}：</span>
						<span>¥{{item.server_price}}</span>
					</li>
				</ul>
				<div class="show_service" :class="moreArrow?'show_more':'show_less'" @click="showMore" v-if='isShowMore'></div>
			</div>	
			
			<div class='service-mixs'>
				<div  class='service-two'>
					<h1>联系信息<span>*</span></h1>
					<ul  v-if="orderInfo && orderInfo.server_type==1">
						<li v-for='index in linkNum' :key="index">
							<img src="../../assets/img/goodsLink.png">
							<span>商品链接</span>
							<input type="text" placeholder="请输入宝贝链接"  v-model='goodsLinkUrl[index-1]'>
							<img src="@/assets/img/ic_add.png" class="add-url" @click='linkNum++' v-show="index==1">
							<img src="@/assets/img/ic_shanchu.png" class="add-url" @click='linkNum--' v-show="index!=1">
						</li>
						<li>
							<img src="../../assets/img/saler.png">
							<span>卖家旺旺</span>
							<input type="text" placeholder="请输入卖家旺旺账户" v-model="orderInfo.merchant_wangwang">
                            <img src="@/assets/img/ic_common.png" class="add-url" @click="selectUsedWang">
						</li>
						<li>
							<img src="../../assets/img/buy.png">
							<span>买家旺旺</span>
							<input type="text" placeholder="请输入买家旺旺账户" v-model="orderInfo.consumer_wangwang">
						</li>
					</ul>
					
					<ul v-else>
						<li v-for='index in linkNum' :key="index">
							<img src="../../assets/img/goodsLink.png">
							<span>商家网址</span>
							<input type="text" placeholder="请输入网店链接"  v-model='goodsLinkUrl[index-1]'>
							<img src="@/assets/img/ic_add.png" class="add-url" @click='linkNum++' v-show="index==1">
							<img src="@/assets/img/ic_shanchu.png" class="add-url" @click='linkNum--' v-show="index!=1">
						</li>
						<li>
							<img src="../../assets/img/ic_shouji.png">
							<span>顾客手机</span>
							<input type="tel" placeholder="请输入顾客手机" maxlength="11" v-model="orderInfo.consumer_mobile">
						</li>
						<li>
							<img src="../../assets/img/buy.png">
							<span>顾客姓名</span>
							<input type="text" placeholder="请输入顾客姓名" v-model="orderInfo.consumer_name">
						</li>
					</ul>
				</div>
				
				<div class='service-three'>
					<h1>截图信息
                        <span>*</span>
                        <em @click="onPreview">查看示例</em>
                        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="serverImg"/>
                    </h1>
					<p>{{orderInfo.message}}</p>
                    <imageUpload v-model="orderInfo.order_images" :limit="9"/>
				</div> 
			</div>
			
			<div v-show='!isCaseShow'>
				<div class="more" @click='isCaseShow=true'></div>
				<p class="total">合计金额：<span>¥{{serverPrice}}元</span></p>
			</div>
		</div>
		
		<!-- 情况备注 -->
		<div class="case-box" v-show='isCaseShow'>
			<div class="case-first">
				<h1>情况备注<span>（非必填）</span></h1>
				<div class="textarea-wrap">
					<textarea rows="3" cols="20" placeholder="请您描述原因" maxlength="500" v-model="orderInfo.order_details"></textarea>
					<span>{{orderInfo.order_details.length}}/500</span>
				</div>
				
				<ul class='case-list'>
					<li v-for='(item,index) in caseList' :key='index' :class='item.tagFlag?"active":""' @click="selectCase(item,index)">
						{{item.name}}
					</li>
				</ul>
			</div>	
            
            <div class="case-two">
				<h1>售后特权<span  @click="isShowTips=true">（非必填）</span></h1>
            	<ul class='after-sale'>
            		<li v-for='(item,index) in afterList' :key='index' :class='saleFlag==index?"active":""' @click="selectAfterSale(item,index)">
            			<span>{{item.name}}<em v-if='index == 1 '><input type="number" v-model="orderInfo.compensation_price"/>元</em></span>
                        <input type="text" v-if='index == 3' v-model="orderInfo.other_sale_massage"/>
            		</li>
            	</ul>
            </div>	
            
            <div>
            	<div class="retract" @click='isCaseShow=false'></div>
            	<p class="total">合计金额：<span>¥{{serverPrice}}元</span></p>
            </div>
		</div>
        
        <footer>
            <p @click='isAgree = !isAgree'>
               <span :class='isAgree?"current":""'>查看并同意</span> 
               <em @click="isShowAgree=true">《用心淘下单协议》</em>
            </p>
            <div class="next" @click="submitNext">下一步</div>
        </footer>
        
		<!-- 下单协议 -->
		<agree-ment-modal v-if="isShowAgree" @close="isShowAgree = false"></agree-ment-modal>
		
		<common-modal v-if="isShowTips" :is-show-close="isShowClose" @close="isShowTips = false">
			<div class="agree-wrap">
				<div class="agree-text">
					<p>增加此权限给予处理人员更多的权限，可提高处理效率及成功率</p>
				</div>
			</div>
		</common-modal>
        
        <!-- 选择卖家旺旺 -->
        <used-wang-list v-if='isShowWang' :wangList='wangList' @submitWang='submitWang'  @close="isShowWang = false"></used-wang-list>
	</section>
</template>

<script>
    import UsedWangList from '@/components/usedWangList.vue';
	import CommonModal from '@/components/commonModal.vue';
    import BreadCrumb from '@/components/BreadCrumb.vue';	
    import ImageUpload from '@/components/ImageUpload.vue';	
	import agreeMentModal from '@/components/agreeMentModal';
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
    import {getServer,getOrderDetail,getOrderHistory,placeOrder,getQuickTag,getUserWangWang} from '@/api/order';
    import {mapState} from "vuex";
    import utils from '@/assets/js/utils';
export default {
    data() {
    	return {
			flag:sessionStorage.getItem("flag") || 0,
            caseFlag:sessionStorage.getItem("caseFlag") || -1,
			clickTagList:JSON.parse(sessionStorage.getItem("clickTagList")) || [],
            saleFlag:-1,
			caseList:[],
            afterList:[
                {type:"1",name:"除处理费用外，商家还同意消费者退货退款"},
            	{type:"2",name:"除处理费用外，商家还愿意额外补偿消费者"},
                {type:"3",name:'除处理费用外，商家还同意消费者不退货退款'},
                {type:"4",name:"其它"}	
            ],
            isCaseShow:false,
			moreArrow:false,				//展示下拉收起箭头
			isShowMore:false,				//是否需要下拉箭头
            serverList:[],                   //服务项目
			serverListShort:[],
			serverListAll:[],
            serverPrice:"",                  //项目价格
            serverImg:[],
            orderInfo:{
                server_uuid:"",
                server_type:"",
                
            	question_url:"",
            	consumer_wangwang:"",
            	merchant_wangwang:"",
				
				consumer_mobile:"",
				consumer_name:"",
                
                order_images:[],
                after_sale_type:"",         //售后类型
            	compensation_price:"",      //补偿金额
            	other_sale_massage:"", 	    //其它情况
                
            	order_details:"" ,          //实际情况
				message:""
            },
            showViewer: false,             // 显示查看器
			isShowAgree:false,
			isAgree:false,
			isShowTips:false,
			isShowClose:true,
			linkNum:1,
			goodsLinkUrl:[],
            isShowWang:false,
            wangList:[]
		};
    },
    
    created(){
        this.getOrderHistory();
        this.getServer();
        this.getQuickTagList();
        if(sessionStorage.getItem("placeOrderId")){//从订单确认页返回
            var orderId = sessionStorage.getItem("placeOrderId");
            this.getOrderDetail(orderId);
        }
    },
    
    computed: {
    	...mapState(["communalInfo"]),
    },
    
    methods:{   
        //获取服务项目
        async getServer(){
        	const { data, status } = await getServer();
        	if (status !== 200) return 
        	let serverList = data.char;
            this.serverPrice = serverList[0].server_price;
            this.serverImg = serverList[0].case_img;
            this.orderInfo.server_uuid = serverList[0].uuid;
            this.orderInfo.server_type = serverList[0].type;
			this.orderInfo.message = serverList[0].message;
			if(serverList.length > 6){
				this.serverListAll = serverList;
				this.serverListShort = serverList.slice(0,6);
				this.serverList = [...this.serverListShort];
				this.isShowMore = true;
				this.moreArrow = true;
			}
			else{
				this.serverList = serverList;
				this.isShowMore = false;
				this.moreArrow = false;
			}
            if(this.serverImg.length){
                this.serverImg = this.serverImg.map((item)=>{
                    if(item.indexOf("https" || "http") == -1){
                    	return (this.communalInfo.BucketDomain + item)
                    }
                })
            }
            else{
                this.$message("暂无图片")
            }
        },
        
        //选择服务项目
        selectServer(item,index){
            this.serverPrice = item.server_price;
            this.serverImg = item.case_img;
            this.orderInfo.server_uuid = item.uuid;
            this.orderInfo.server_type = item.type;
			this.orderInfo.message = item.message;
            this.flag = index;
            if(this.serverImg.length){
                this.serverImg = this.serverImg.map((item)=>{
                    if(item.indexOf("https" || "http") == -1){
                    	return (this.communalInfo.BucketDomain + item)
                    }
                })
            }
            else{
                this.$message("暂无图片");
            }
        },
		
		//展示更多服务项目
		showMore(){
			if(this.moreArrow){
				this.serverList = [...this.serverListAll];
				this.moreArrow = false
			}
			else{
				this.serverList = [...this.serverListShort];
				this.moreArrow = true
			}
		},
        
        //获取情况备注
        async getQuickTagList(){
        	const { data, status } = await getQuickTag();
        	if (status !== 200) return ;
            var list = data.data;
        	this.caseList = [...list];
			if(this.clickTagList.length){
				this.clickTagList.forEach((obj,idx)=>{
					this.caseList.forEach((item,index)=>{
						this.$set(this.caseList[obj],"tagFlag",true);
					})
				})
			}
        },
        
        //选择大概情况
        selectCase(item,index){
			if(!item.tagFlag){
                if(this.orderInfo.order_details.length > 499){
                    this.$message("字数已达上限");
                    return
                }
				this.$set(item,"tagFlag",true);
				this.clickTagList.push(index)
				if(this.orderInfo.order_details && this.orderInfo.order_details.slice(-1)!=","){//手动输入没有输入逗号，则选择下个标签的时候前面要加上
					this.orderInfo.order_details += ","+item.name+',';
				}else{
					this.orderInfo.order_details += item.name+',';
				}
                if(this.orderInfo.order_details.length > 500){
                    this.orderInfo.order_details = this.orderInfo.order_details.slice(0,500)
                }
			}
			else{
				this.$set(item,"tagFlag",false);
				this.clickTagList.forEach((obj,idx)=>{
					if(obj == index){
						this.clickTagList.splice(idx,1);
					}
				})
				this.orderInfo.order_details = this.orderInfo.order_details.replace(item.name+",",'');
			}
        },
        
        //选择售后特权
        selectAfterSale(item,index){
            this.orderInfo.after_sale_type = item.type;
            this.saleFlag = index;
            if(this.orderInfo.after_sale_type == "2"){//除处理费用外，商家还愿意额外补偿消费者，清空其它信息
                this.orderInfo.other_sale_massage = ""
            }
            else if(this.orderInfo.after_sale_type == "4"){//其它，清空补偿金
                this.orderInfo.compensation_price = ""
            }
        },
        
        //获取上次填写的下单信息，用于信息回填
        async getOrderDetail(order_uuid){
        	const { data, status } = await getOrderDetail(order_uuid);
        	if (status == 200){ 
                this.orderInfo = data;
                this.saleFlag = (this.orderInfo.after_sale_type) - 1;
                this.imgList = this.orderInfo.order_images;
                if(!this.orderInfo.compensation_price || !(Number(this.orderInfo.compensation_price))){
                    this.orderInfo.compensation_price = ""
                }
				this.orderInfo.message = this.orderInfo.server_info.message;
				if(this.orderInfo.question_url){
					this.goodsLinkUrl = this.orderInfo.question_url.split(",");
					this.linkNum = this.goodsLinkUrl.length;
				}
            }
        },
        
        //获取用户上次填写的商家信息
        async getOrderHistory(){
        	const { data, status } = await getOrderHistory();
        	if (status !== 200) return
        	if(data.data){
        		this.orderInfo.merchant_wangwang = data.data.merchant_wangwang;
        	}
        },
        
        //获取用常用旺旺号
        async selectUsedWang(){
        	const { data, status } = await getUserWangWang();
        	if (status !== 200) return;
        	if(data.char && data.char.length > 0){
        		if(data.char.length > 10){
        			this.wangList = data.char.slice(0,10);
        		}else{
        			this.wangList = data.char;
        		}
        		this.isShowWang=true;
        	}else{
        		this.$message('您暂无常用旺旺，请输入');
                return
        	}
        },
        
        //确定旺旺
        submitWang(wangWang){
        	this.orderInfo.merchant_wangwang = wangWang;
        	this.isShowWang = false;
        },
        
        // 点击下一步,服务下单
        submitNext(){
            let {server_type,consumer_wangwang,merchant_wangwang,consumer_mobile,consumer_name,after_sale_type,compensation_price,other_sale_massage,order_details,order_images} = this.orderInfo;
        	if(!this.goodsLinkUrl[0]){
        		if(server_type=="1"){
        			this.$message("请输入宝贝链接");
        			return
        		}else{
        			this.$message("请输入网店链接");
        			return
        		}
        	}

			if(server_type=="1"){
				consumer_mobile = "";		//置空非淘宝填写信息
				consumer_name = "";
				if(!consumer_wangwang){
					this.$message("请输入买家旺旺号");
					return
				}
				if(!merchant_wangwang){
					this.$message("请输入消商家旺旺号");
					return
				}
			}else{
				merchant_wangwang = "";		//置空淘宝填写信息
				consumer_wangwang = "";
				if(!(/^1[0123456789]\d{9}$/.test(consumer_mobile))){
					this.$message("顾客手机号有误");
					return
				}
				if(!consumer_name){
					this.$message("请输入顾客姓名");
					return
				}
			}
			
        	if(after_sale_type =="2"){
        		if(!(/^[1-9]\d*(,\d{3})*(\.\d{2})?$/).test(compensation_price)){
        			this.$message("补偿金输入有误",);
        			return
        		}
        	}
            
            if(after_sale_type =="4"){
            	if(!other_sale_massage){
            		this.$message("请输入售后信息");
            		return
            	}
            }
        	
        	if(order_details){
        		if(order_details.length>500){
        			this.$message("实际情况描述不得超过500字符");
        			return
        		}
        	}
        	
        	if(!order_images.length){
        		this.$message("请上传图片");
        		return
        	}
			this.goodsLinkUrl = this.goodsLinkUrl.filter((item,index)=>{
				return item!=""
			});
			this.orderInfo.question_url = this.goodsLinkUrl.join();
			if(!this.isAgree){
				this.$message("请阅读并勾选协议");
				return
			}
        	this.placeOrder(this.orderInfo);
        },
        
        // 服务下单
        async placeOrder(obj){
        	const { data, status } = await placeOrder(obj);
        	if (status !== 200) return 
        	this.$router.push({path:"./confirm-order",query: {order_uuid:data.order_uuid}});
            sessionStorage.setItem("flag",this.flag);
            sessionStorage.setItem("caseFlag",this.caseFlag);
			sessionStorage.setItem("clickTagList",JSON.stringify(this.clickTagList));
            sessionStorage.setItem("placeOrderId",data.order_uuid);           //缓存下单服务下单生成的订单号，用户信息回填
        },
        
        onPreview(){
            this.showViewer = true;
            this.handleClickItem()
        },
        
        closeViewer(){
            this.showViewer = false;
        },
        
        handleClickItem(){
            this.$nextTick(()=>{
                // 获取遮罩层dom
                let domImageMask = document.querySelector(".el-image-viewer__mask");
                if (!domImageMask) {
                  return;
                }
                domImageMask.addEventListener("click", () => {
                    // 点击遮罩层时调用关闭按钮的 click 事件
                    document.querySelector(".el-image-viewer__close").click();
                    this.closeViewer();
                });
            })
        }
    },
    
	components:{
        UsedWangList,
		CommonModal,
	    BreadCrumb,
        ImageUpload,
        ElImageViewer,
		agreeMentModal
	}
};
</script>

<style>
    .el-image-viewer__close{
        color: #fff;
    }
</style>

<style lang="scss" scoped>
    @include input-nubmer;
	input::-webkit-input-placeholder { /* WebKit browsers 适配谷歌 */
	    @include textarea-placeholder;
		font-size: 12px;
	}
	input:-moz-placeholder { /* Mozilla Firefox 4 to 18 适配火狐 */
	    @include textarea-placeholder;
		font-size: 12px;
	}
	input::-moz-placeholder { /* Mozilla Firefox 19+ 适配火狐 */
		@include textarea-placeholder;
		font-size: 12px;
	}
	input:-ms-input-placeholder { /* Internet Explorer 10+  适配ie*/
	    @include textarea-placeholder;
	    font-size: 12px;
	}
	
	
	textarea::-webkit-input-placeholder { /* WebKit browsers 适配谷歌 */
	    @include textarea-placeholder;
	}
	textarea:-moz-placeholder { /* Mozilla Firefox 4 to 18 适配火狐 */
	    @include textarea-placeholder;
	}
	textarea::-moz-placeholder { /* Mozilla Firefox 19+ 适配火狐 */
		@include textarea-placeholder;
	}
	textarea:-ms-input-placeholder { /* Internet Explorer 10+  适配ie*/
	    @include textarea-placeholder;
	}
	
	h1{
		@include font-style;
		font-size: 20px;
		color: #000000;
		margin-bottom: 30px;
		position: relative;
		span{
			color:#FE860E
		}
		em{
			font-size: 14px;
			@include font-style;
			color: #FE860E;
			font-style: normal;
			position: absolute;
			right: 0;
		}
	}
    .total{
    	font-size: 20px;
    	@include font-style;
    	color: #000000;
    	span{
    		margin-left: 35px;
    		font-size: 22px;
    		color: #FF8E1C;
    	}
    }
	.service-box{
		padding: 30px;
		background: #FFFFFF;
		box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
		.service-first{
			.service-list{
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				li{
					// padding: 16px 72px;
					@include cursor-style;
					width: 300px;
					height: 48px;
					text-align: center;
					box-sizing: border-box;
					line-height: 48px;
					margin-bottom: 30px;
					background: #FFFFFF;
					border: 1px solid #FE860E;
					border-radius: 5px;
					font-size: 16px;
					@include font-style;
					color: #FF8E1C;
				}
				li:nth-child(3n){
					margin-right: 0;
				}
				.current{
					background: #FE860E;
					font-size: 16px;
					color: #FFFFFF;
				}
			}
			@media only screen and (max-device-width: 1440px) {
				.service-list {
					justify-content: flex-start;
					li{
						margin-right: 16px;
					}
				}
			}
			.show_service{
				cursor: pointer;
				display: block;
				margin: 0 auto 20px;
				width: 22px;
				height: 12px;
			}
			.show_more{
				background: url(../../assets/img/more.png) no-repeat center;
				background-size: 22px;
			}
			.show_less{
				background: url(../../assets/img/up.png) no-repeat center;
				background-size: 22px;
			}
		}
		
		.service-mixs{
			display: flex;
			.service-two{
				margin-right: 90px;
				li{
					display: flex;
					align-items: center;
					margin-bottom: 20px;
					img{
						width: 18px;
						height: 18px;
						cursor: pointer;
					}
					span{
						@include font-style;
						font-size: 16px;
						color: #343434;
						padding: 0 14px;
					}
					input{
						appearance: none;
						outline: none;
						outline: none;
						width: 312px;
						height: 44px;
						background: #F5F9FC;
						padding-left: 30px;
						margin-right: 10px;
					}
				}
				li:last-child{
					margin-bottom: 0;
				}
			}
			.service-three{
				flex: 1;
				p{
					font-size: 14px;
					color: #9A9A9A;
					@include font-style;
					margin-bottom: 30px;
				}
                em{
                    @include cursor-style
                }
				.information-icon >>> .el-upload{
					width: 150px;
					height: 120px;
					line-height: 120px;
					border-radius: 0;
					background: #FFFFFF;
					border: 1px solid #ECECEC;
					
				}
				.information-icon >>> .el-icon-plus{
					color: #000;
				}
			}
		}
		.more{
			width: 22px;
			height: 12px;
			margin: 50px auto 20px auto;
			@include cursor-style;
			background: url(../../assets/img/more.png) no-repeat center;
			background-size: 22px;
		}
	}
	
	.case-box{
		padding: 30px;
		margin-top: 30px;
		background: #FFFFFF;
		box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
		.case-first{
			h1{
				font-size: 22px;
				color: #000000;
				span{
					margin-left: 20px;
					font-size: 14px;
					@include font-style;
					color: #9A9A9A;
				}
			}
			.textarea-wrap{
                background: #F5F9FC;
                padding: 20px 15px 15px 20px;
				textarea{
					width: 100%;
					height: 180px;
					box-sizing: border-box;
					background: #F5F9FC;
					resize: none;
                    font-size: 14px;
					// word-break: break-all;
				}
				span{
					display: block;
					text-align: right;
                    margin-top: 5px;
				}
			}
			.case-list{
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				margin-top: 30px;
				li{
                    @include cursor-style;
					height: 36px;
                    padding: 0 10px;
					box-sizing: border-box;
					margin-bottom: 20px;
					margin-right: 20px;
					line-height: 36px;
					text-align: center;
					background: #FFFFFF;
					border: 1px solid #9A9A9A;
					border-radius: 5px;
					font-size: 14px;
					@include font-style;
					color: #9A9A9A;
				}
                .active{
                    background: #999999a8;
                    color: #fff;
                    border: none;
                }
				
			}
			
		}
        
        .case-two{
			padding: 30px 0;
			h1{
				font-size: 22px;
				color: #000000;
				margin-bottom: 20px;
				span{
					margin-left: 20px;
					font-size: 14px;
					@include font-style;
					color: #9A9A9A;
					cursor: pointer;
					padding-right: 15px;
					background: url(../../assets/img/question.png) no-repeat right center;
					background-size: 15px;
				}
			}
            .after-sale{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                li{
                    width: 50%;
                    font-size: 14px;
                    @include font-style;
                    @include cursor-style;
                    color: #333333;
                    padding-left: 35px;
                    margin-top: 20px;
                    box-sizing: border-box;
                    background: url(../../assets/img/un-select.png) no-repeat left center;
                    background-size: 16px;
                    input{
                        appearance: none;
                        border: none;
                        outline: none;
                        width: 160px;
                        border-bottom: 1px solid #333;
                        padding-left: 10px;
                        text-align: center;
                    }
                    em{
                        font-style: normal;
                        input{
                            width: 60px;
                        }
                    }
                }
                li:nth-child(-n+2){
                    margin-top: 0;
                }
                .active{
                    background: url(../../assets/img/select.png) no-repeat left center;
                    background-size: 16px;
                }
            }
        }
        
        .retract{
        	width: 22px;
        	height: 12px;
        	margin: 50px auto 20px auto;
        	@include cursor-style;
        	background: url(../../assets/img/up.png) no-repeat center;
        	background-size: 22px;
        }
	}
    footer{
        margin-top: 30px;
        p{
            text-align: center;
            @include cursor-style;
            span{
               font-size: 18px;
               @include font-style;
               color: #999999;
               padding-left: 38px;
               background: url(../../assets/img/un-select.png) no-repeat left center;
               background-size: 18px; 
            }
			.current{
				background: url(../../assets/img/select.png) no-repeat left center;
				background-size: 18px;
			}
            em{
                font-style: normal;
				font-family: Microsoft YaHei;
				font-size: 18px;
                color: #000000;
            }
        }
        div{
            @include cursor-style;
            width: 380px;
            height: 80px;
            margin: 30px auto 0 auto;
            line-height: 80px;
            text-align: center;
            background: #FF8D1C;
            box-shadow: 0px 8px 10px 0px rgba(31, 56, 117, 0.08);
            border-radius: 5px;
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
        }
    }
	
	.agree-wrap{
	    h1{
	        border-bottom: 0.026667rem solid #E9E9E9;
	        padding: 15px;
	        text-align:center;
	        @include font-style;
	        font-size: 20px;
	        color: #000000;
	    }
	    .agree-text{
	        box-sizing: border-box;
	        padding: 40px;
	        background: #FFFFFF;
	        line-height:30px;
	        letter-spacing: 2px;
	        p{
	            margin-bottom: 20px;
	        }
	        p:last-child{
	            margin-bottom: 0;
	        }
	    }
	}
    
    /* 选择旺旺 */
    .modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 20px;}
    .agree-modal{width: 100%;}
    .title{padding: 12px 21px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
    .wang-wrap{padding: 18px 20px 17px 20px;/* height: 500px;overflow: auto; */}
    .wang-wrap li{display: flex;justify-content: space-between;align-items:center;margin-bottom: 15px;}
    .modal-title{font-size:15px;color:rgba(20,20,20,1);max-width: 88%;}
	
</style>